module.exports = __webpack_public_path__ + "img/prop-rose-right.24cb277f.png";